import React from 'react';
import { Link } from 'react-router-dom';
import './PlancherBoutiquePage.css';

const PLANCHER_MESSAGE = 'Bois franc canadien à partir de 3,99 $';

function PlancherBoutiquePage() {
  return (
    <div className="plancher-boutique-page">
      <div className="page-header">
        <div className="container">
          <h1>Plancher</h1>
          <p>Découvrez nos différents types de plancher</p>
        </div>
      </div>

      <section className="plancher-boutique-section" id="bois-franc">
        <div className="container">
          <div className="section-header">
            <h2>Bois Franc</h2>
            <p className="section-subtitle">Plancher en bois franc de haute qualité</p>
          </div>
          <div className="plancher-product-message">
            <p>{PLANCHER_MESSAGE}</p>
          </div>
        </div>
      </section>

      <section className="plancher-boutique-section" id="vinyl" style={{ backgroundColor: '#ffffff' }}>
        <div className="container">
          <div className="section-header">
            <h2>Vinyl</h2>
            <p className="section-subtitle">Plancher vinyl résistant et facile d'entretien</p>
          </div>
          <div className="empty-section">
            <p>Photos à venir</p>
          </div>
        </div>
      </section>

      <section className="plancher-boutique-section" id="flottant">
        <div className="container">
          <div className="section-header">
            <h2>Flottant</h2>
            <p className="section-subtitle">Plancher flottant économique et polyvalent</p>
          </div>
          <div className="empty-section">
            <p>Photos à venir</p>
          </div>
        </div>
      </section>

      <section className="plancher-boutique-cta">
        <div className="container">
          <h2>Besoin d'aide pour choisir votre plancher?</h2>
          <p>Contactez-nous pour des conseils personnalisés et une estimation gratuite</p>
          <Link to="/contact" className="cta-button">
            Nous Contacter
          </Link>
        </div>
      </section>
    </div>
  );
}

export default PlancherBoutiquePage;
